module.exports = __webpack_public_path__ + "img/6.a5c59901.svg";